import { useMutation } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getKycInfo } from "../../../transactions/kyc/kyc";
import usePersonStore from "../../../store/personStore";


export const KycRedirect = () => {
    const [searchParams] = useSearchParams();
    console.log(searchParams.get('code'), searchParams.get('state'));

    const navigate = useNavigate();

  const { showRetailDashboard } = usePersonStore();

    
    const mutation = useMutation({
        mutationFn: (payload) => getKycInfo(payload),
        onSuccess: (data) => {
            navigate(`/track-your-car/details/${searchParams.get('state')}`,{state:{status:data.data.status === 'fail'? 'failed':'success'}}) 
        }
      });

    useEffect(() => {
        if (searchParams && searchParams.get('code') && searchParams.get('state')) {
            let cncode = searchParams.get('state');
            let code = encodeURIComponent(searchParams.get('code')); 
            console.log(cncode, code)
            mutation.mutate({ cncode: cncode, code: code })
      }
        else if (searchParams && searchParams.get('error') && searchParams.get('state')) {
          navigate(`/track-your-car/details/${searchParams.get('state')}`,{state:{status:'failed'}}) 
      }
    },[searchParams])

    return (
        <div className="container mx-auto flex items-center justify-center"
    style={{
      height: showRetailDashboard ? 'calc(100vh - 150px)' : 'calc(100vh - 76px)',
      }}
        >
            <p>Μην κλείσεις το παράθυρο, πραγματοποιείται ανακατεύθυνση.</p>
    </div>

    )
}